module.exports = __webpack_public_path__ + "img/Off-Duty-Boots.db8d2807.jpg";